import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

const HOME_ROUTE_BY_ROLE = { admin: "/admin", photographer: "/photographer/portal" };

export function ProtectedRoute({ children, role, roles }) {
  const { user, loading } = useAuth();

  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-6 w-6 animate-spin text-slate-400" />
      </div>
    );

  if (!user) return <Navigate to="/login" replace />;
  if ((role && user.role !== role) || (roles && !roles.includes(user.role)))
    return <Navigate to={HOME_ROUTE_BY_ROLE[user.role] || "/dashboard"} replace />;

  return children;
}
